import { Store, Module, ActionContext } from "vuex";
import ListModule from "./list-module";
import ListState from "./list-state";
import Client from "../entities/client";
import Ajax from "../../lib/ajax";
import PageResult from "@/store/entities/page-result";

interface ClientState extends ListState<Client> {
  editClient: Client;
  permissions: Array<string>;
  clientsForSelect: Client[];
  masterData: [];
  shippingServices: [];
  extraServices: [];
  assetTypeServices: [];
  clientAssetTypes: Array<any>;
  clientShippingServices: [];
  totalCountConfig: number;
  currentPageConfig: number;
  pageSizeConfig: number;
  listConfig: [];
}
class ClientModule extends ListModule<ClientState, any, Client> {
  state = {
    totalCount: 0,
    currentPage: 1,
    pageSize: 10,
    list: new Array<Client>(),
    loading: false,
    editClient: new Client(),
    permissions: new Array<string>(),
    clientsForSelect: new Array<Client>(),
    masterData: [],
    shippingServices: [],
    extraServices: [],
    assetTypeServices: [],
    clientAssetTypes: [],
    clientShippingServices: [],
    totalCountConfig: 0,
    currentPageConfig: 1,
    pageSizeConfig: 10,
    listConfig: [],
  };
  actions = {
    async getAll(context: ActionContext<ClientState, any>, payload: any) {
      context.state.loading = true;
      let reponse = await Ajax.get("/api/services/app/Client/GetAll", {
        params: payload.data,
      });
      context.state.loading = false;
      let page = reponse.data.result as PageResult<Client>;
      context.state.totalCount = page.totalCount;
      context.state.list = page.items;
    },
    async create(context: ActionContext<ClientState, any>, payload: any) {
      await Ajax.post("/api/services/app/Client/Create", payload.data);
    },
    async update(context: ActionContext<ClientState, any>, payload: any) {
      await Ajax.put("/api/services/app/Client/Update", payload.data);
    },
    async delete(context: ActionContext<ClientState, any>, payload: any) {
      await Ajax.delete(
        "/api/services/app/Client/Delete?Id=" + payload.data.id
      );
    },
    async get(context: ActionContext<ClientState, any>, payload: any) {
      let reponse = await Ajax.get(
        "/api/services/app/Client/GetById?id=" + payload.id
      );
      context.state.editClient = reponse.data.result;
      return reponse.data.result as Client;
    },
    async getListForSelect(
      context: ActionContext<ClientState, any>,
      payload: any
    ) {
      let reponse = await Ajax.get(
        "/api/services/app/Client/GetClientsForSelect",
        { params: payload.data }
      );
      context.state.clientsForSelect = reponse.data.result.items as Client[];
    },
    async getMasterData(context: ActionContext<ClientState, any>) {
      let reponse = await Ajax.get(
        "/api/services/app/MasterDataService/GetAll"
      );
      context.state.masterData = reponse.data.result.items;
    },
    async getShippingServices(context: ActionContext<ClientState, any>) {
      let reponse = await Ajax.get(
        "/api/services/app/MasterDataService/GetAllShippingSerivce"
      );
      context.state.shippingServices = reponse.data.result.items;
    },
    async getExtraServices(context: ActionContext<ClientState, any>) {
      let reponse = await Ajax.get(
        "/api/services/app/MasterDataService/GetAllExtraService"
      );
      context.state.extraServices = reponse.data.result.items;
    },
    async getAssetTypeServices(context: ActionContext<ClientState, any>) {
      let reponse = await Ajax.get(
        "/api/services/app/MasterDataService/GetAllAssetTypeService"
      );
      context.state.assetTypeServices = reponse.data.result.items;
    },
    async getClientAssetTypeServices(
      context: ActionContext<ClientState, any>,
      payload: any
    ) {
      let reponse = await Ajax.get(
        "/api/services/app/Client/GetClientAssetTypes?Code=" + payload.data
      );
      context.state.clientAssetTypes = reponse.data.result.items;
    },
    async createAddress(
      context: ActionContext<ClientState, any>,
      payload: any
    ) {
      let reponse = await Ajax.post(
        "/api/services/app/MasterDataService/Create",
        payload.data
      );
      const { id, fullAddress } = reponse.data.result;
      context.state.editClient = {
        ...context.state.editClient,
        addressId: id,
        fullAddress: fullAddress,
      };
    },
    async updateStatus(context: ActionContext<ClientState, any>, data: any) {
      const { payload } = data;
      await Ajax.put(
        "/api/services/app/Client/UpdateStatus?id=" + payload.id,
        {}
      );
    },
    async getClientShippingServices(
      context: ActionContext<ClientState, any>,
      payload: any
    ) {
      const {
        data: { result },
      } = await Ajax.get(
        "/api/services/app/Client/GetClientShippingServices/" + payload.data
      );
      context.state.clientShippingServices = result.items;
    },
    async getClientAssetTypesForSelect(
      context: ActionContext<ClientState, any>,
      payload: any
    ) {
      let reponse = await Ajax.get(
        "/api/services/app/Client/GetClientAssetTypesForSelect",
        { params: payload.data }
      );
      return reponse.data.result.items;
    },
    async searchNotificationConfigs(
      context: ActionContext<ClientState, any>,
      payload: any
    ) {
      let reponse = await Ajax.get(
        "/api/services/app/Client/SearchNotificationConfigs",
        {
          params: payload.data,
        }
      );
      context.state.loading = false;
      context.state.totalCountConfig = reponse.data.result.totalCount;
      context.state.listConfig = reponse.data.result.items;
      return reponse.data.result.items;
    },
    async checkNotificationConfigExisted(
      context: ActionContext<ClientState, any>,
      payload: any
    ) {
      let reponse = await Ajax.get(
        "/api/services/app/Client/CheckNotificationConfigExisted",
        {
          params: payload.data,
        }
      );
      return reponse.data.result;
    },
    async deleteNotificationConfig(
      context: ActionContext<ClientState, any>,
      payload: any
    ) {
      const reponse = await Ajax.put(
        "/api/services/app/Client/DeleteNotificationConfig?id=" +
          payload.data.id
      );
      return reponse.data.result;
    },
    async deleteAllNotificationConfig(
      context: ActionContext<ClientState, any>,
      payload: any
    ) {
      const reponse = await Ajax.put(
        "/api/services/app/Client/DeleteAllNotificationConfig?warehouseCode=" +
          payload.data.warehouseCode
      );
      return reponse.data.result;
    },
  };
  mutations = {
    setCurrentPage(state: ClientState, page: number) {
      state.currentPage = page;
    },
    setPageSize(state: ClientState, pagesize: number) {
      state.pageSize = pagesize;
    },
    edit(state: ClientState, role: Client) {
      state.editClient = role;
    },
    updateService(state: ClientState, payload: any) {
      state.editClient[payload.moduleName] = payload.data;
    },
    setCurrentPageConfig(state: ClientState, page: number) {
      state.currentPageConfig = page;
    },
    setPageSizeConfig(state: ClientState, pagesize: number) {
      state.pageSizeConfig = pagesize;
    },
    resetListConfig(state: ClientState) {
      state.currentPageConfig = 0;
      state.currentPageConfig = 10;
      state.listConfig = [];
    },
  };
}
const roleModule = new ClientModule();
export default roleModule;
